import React, { createContext, useContext, useState } from "react"
import { Employee } from "../Objects/Employee/Employee"

interface UserContextProps {
  userEmployee: Employee | null
  setEmployee: (employeeLogged: Employee | null) => void
}

const UserContext = createContext<UserContextProps | undefined>(undefined)

export const UserProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [userEmployee, setEmployeeState] = useState<Employee | null>(() => {
    const storedEmployee = localStorage.getItem("userEmployee")

    return storedEmployee ? new Employee(JSON.parse(storedEmployee)) : null
  })

  const setEmployee = (employeeLogged: Employee | null) => {
    setEmployeeState(employeeLogged)

    if (employeeLogged) {
      localStorage.setItem("userEmployee", JSON.stringify(employeeLogged))
    } else {
      localStorage.removeItem("userEmployee")
    }
  }

  return <UserContext.Provider value={{ userEmployee, setEmployee }}>{children}</UserContext.Provider>
}

export const useEmployerLogged = () => {
  const context = useContext(UserContext)

  if (!context) {
    throw new Error("useEmployerLogged deve ser usado dentro de um UserProvider")
  }

  return context
}

export {}
